import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Activities from "@/components/Activities";
import Practical from "@/components/Practical";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <About />
        <Activities />
        <ContactSection />
      </main>
      <Footer />
    </>
  );
}
